import SearchBox from "../../components/components-library/searchbox";
import {
  ArrowDropDown,
  FilterAltOutlined,
  RefreshSharp,
} from "@mui/icons-material";
import useMarkets from "./useMarkets";
import { Button, PanelSlider, TabsList } from "../../components/ui";
import {
  resetMarketDetails,
  setActiveMarketTab,
  setMarketAddEditVal,
  setOpenMarketAddPanel,
  setOpenMarketDetailsPanel,
  setRefreshAllMarketsEntity,
  setSelectedMarketId,
} from "../../reducers/marketSlice";
import MarketDetailsById from "./market-details-by-id";
import AddMarket from "./market-details-by-id/add-market";
import useMarketFilters from "./useMarketsFilters";
import MarketsFilters from "./market-filters-panel";
import cancelIcon from "../../assets/images/close.svg";
import { useDispatch } from "react-redux";
import MarketsTable from "./all-markets-table";
import { useUIPermissions } from "../../layout/config/permissionUtils";
const Markets = () => {
  const dispatch = useDispatch();
  const {
    searchText,
    setSearchText,
    openStausFilter,
    openMarketDetailsPanel,
    marketAddPanel,
    marketDetailsEditStatus,
    filteredMarketsData,
    setAllMarketsRefresh,
    allMarketsRefresh,
    marketsFiltersPanelOpenStatus,
    marketAddEditVal,
    loading,
    roleType,
    activeMarketTab,
  } = useMarkets();
  const { hasAdminManagerEditAccess } = useUIPermissions();
  const { isFilterApplied } = useMarketFilters();
  const marketRowOnClick = (rowId: number) => {
    dispatch(setSelectedMarketId(rowId));
    dispatch(setOpenMarketDetailsPanel(true));
    dispatch(setMarketAddEditVal("details"));
  };
  return (
    <>
      {" "}
      <div className="bg-white px-20 border-b">
        <TabsList
          data={[
            { label: "ALL", value: "ALL" },
            { label: "PENDING APPROVALS", value: "PENDING" },
            { label: "REJECTED", value: "REJECTED" },
          ]}
          activeTab={activeMarketTab}
          onChange={(tab, i) => {
            dispatch(setActiveMarketTab(tab.value));
            setSearchText("");
          }}
        />
      </div>
      <div className="outlet_padding">
        <div className=" flex justify-between items-center w-full">
          <div className="w-30">
            {" "}
            <SearchBox
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
              placeholder={"Search by Market Head / Market Name / Market ID"}
            />
          </div>
          {/* <ONOCalendarV2
            mode={dateRange?.mode ?? "MONTHLY"}
            onChangeDate={(fromDate, toDate, mode) => {
              onChangeDateRangeNew(fromDate, toDate, mode);
            }}
            fromDate={dateRange?.fromDate}
            toDate={dateRange?.toDate}
          /> */}

          <div className="flex gap-2 flex-1 justify-end">
            <div
              className="flex items-center cursor-pointer color-primary border-primary px-3 py-1 rounded-full"
              onClick={() => {
                dispatch(setRefreshAllMarketsEntity());
                setAllMarketsRefresh(true);
                setSearchText("");
              }}
              style={{ background: "#EBFFF0" }}
            >
              <RefreshSharp
                className={`${allMarketsRefresh ? "animate-spin" : ""} mr-1`}
              />
              <span className="fs-14 color-primary font-semibold">Refresh</span>
            </div>
            <div className="flex">
              <button
                onClick={() => {
                  openStausFilter(true);
                }}
                className="relative flex items-center bg-white border border-gray color-primary rounded-full
                           px-2 py-2 focus:outline-none focus:ring-2 focus:ring-green-200"
              >
                <FilterAltOutlined className="w-4 h-4" />
                <span className="hidden md:flex fs-14">Filters </span>
                <ArrowDropDown />
                {isFilterApplied() && (
                  <span className="absolute -top-1 -right-1 w-2 h-2 bg-orange-500 rounded-full"></span>
                )}
              </button>
            </div>
            {hasAdminManagerEditAccess && (
              <Button
                // className="w-[100px]"
                variant="contained"
                onClick={() => {
                  dispatch(setOpenMarketAddPanel(true));
                  dispatch(resetMarketDetails());
                }}
              >
                Add Market
              </Button>
            )}
          </div>
        </div>
        <MarketsTable
          data={
            activeMarketTab === "ALL"
              ? filteredMarketsData
              : filteredMarketsData
          }
          loading={loading}
          onRowClick={(row) => {
            marketRowOnClick(row.marketId);
          }}
        />
      </div>
      {openMarketDetailsPanel && (
        <PanelSlider
          direction="right_to_left"
          open={openMarketDetailsPanel}
          onClose={() => {
            if (marketDetailsEditStatus) {
              dispatch(setOpenMarketAddPanel(false));
              dispatch(setMarketAddEditVal("details"));
            } else {
              dispatch(setOpenMarketDetailsPanel(false));
              dispatch(setMarketAddEditVal("edit"));
              // setPanelView("details");
            }
          }}
          style={{ width: "80vw" }}
        >
          <div
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
            className="panel-content"
          >
            {marketAddEditVal === "details" ? (
              <MarketDetailsById
                onEditClick={() => dispatch(setMarketAddEditVal("edit"))}
              />
            ) : (
              <AddMarket
                onBackClick={() => dispatch(setMarketAddEditVal("details"))}
              />
            )}
          </div>
        </PanelSlider>
      )}
      {marketAddPanel && (
        <PanelSlider
          direction="right_to_left"
          open={marketAddPanel}
          onClose={() => {
            dispatch(setOpenMarketAddPanel(false));
          }}
          style={{ width: "80vw" }}
        >
          <div
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
            className="panel-content"
          >
            <AddMarket />
          </div>
        </PanelSlider>
      )}
      {marketsFiltersPanelOpenStatus && (
        <PanelSlider
          direction="right_to_left"
          open={marketsFiltersPanelOpenStatus}
          onClose={() => {
            openStausFilter(false);
          }}
          style={{ width: "30vw" }}
        >
          <div className="py-6 px-4 border-b flex items-center justify-between">
            <div>
              <h2>Filters</h2>
            </div>
            <div>
              <img
                src={cancelIcon}
                className="cursor-pointer"
                onClick={() => {
                  openStausFilter(false);
                }}
                alt=""
              />
            </div>
          </div>

          <div>
            <MarketsFilters />
          </div>
        </PanelSlider>
      )}
    </>
  );
};
export default Markets;
